import type { SearchCustomerResponse } from '@/api/types'
import { atom } from 'jotai'

export const processFlagAtom = atom<
  SearchCustomerResponse['process_flag'] | null
>(null)
export const exportFlagAtom = atom<
  SearchCustomerResponse['export_flag'] | null
>(null)
